type CountryName = {
  code: string;
  name_en: string;
  name_es: string;
};

type LanguageKey = "en" | "es";

const commonNameOverrides: Record<LanguageKey, Record<string, string>> = {
  en: {
    CI: "Ivory Coast",
    CZ: "Czech Republic",
    CV: "Cape Verde",
    GB: "United Kingdom",
    IR: "Iran",
    KP: "North Korea",
    KR: "South Korea",
    MD: "Moldova",
    MK: "North Macedonia",
    RU: "Russia",
    SY: "Syria",
    TL: "East Timor",
    US: "United States",
  },
  es: {
    CI: "Costa de Marfil",
    CZ: "República Checa",
    CV: "Cabo Verde",
    GB: "Reino Unido",
    IR: "Irán",
    KP: "Corea del Norte",
    KR: "Corea del Sur",
    MD: "Moldavia",
    MK: "Macedonia del Norte",
    RU: "Rusia",
    SY: "Siria",
    TL: "Timor Oriental",
    US: "Estados Unidos",
  },
};

export const getCountryDisplayName = (
  country: CountryName,
  language: LanguageKey
) => commonNameOverrides[language][country.code] ?? country[`name_${language}`];
